import { gql } from 'gql/__generated__'

export const CommentatorsFragment = gql(`
  fragment CommentatorsSchema on Commentator {
    employee {
      ...EmployeeSmallSchema
    }
    expiredAt
  }
`)

export const employeePreferencesFragment = gql(`
  fragment EmployeePreferencesSchema on EmployeePreferences {
    templates {
      tab
      editorTemplateGroupId
      editorTemplateGroupName
      templatesType {
        id
        name
      }
      order {
        field
        value
      }
    }
    finder {
      tab
      folder
    }
  }
`)

export const projectListFragment = gql(`
  fragment ProjectListSchema on Project {
    id
    name
    owner {
      ...EmployeeSmallSchema
    }
    isDone
    learningObjectives
    learningGoals
    endDate
    startDate
    accent
    projectGroupId
    updatedAt
    deletedBy
    analytics {
      tasksDone
      tasksTotal
      tasksExpired
    }
    createdBy {
      ...EmployeeSmallSchema
    }
    publicLink {
      ...PublicLinkSchema
    }
    isPublic
    passOrder
    passPercentage
    availability
    displayIncompleteModal
    locale
    localeSettingsName
    localeSettings
    createdAt
    brand {
      id
      name
    }
  }
`)

export const projectFragment = gql(`
  fragment ProjectSchema on Project {
    id
    companyId
    projectGroupId   
    me {
      id
      employee {
        ...EmployeeSmallSchema
      }
      role
    }
    employee {
      ...EmployeeListSchema
    }
    owner {
      ...EmployeeListSchema
    }
    sectionsOrder {
      ...SectionOrderSchema
    }
    accent
    name
    startDate
    endDate
    updatedAt
    learningObjectives
    learningGoals
    projectGroupId
    employee {
      ...EmployeeSmallSchema
    }
    publicLink {
      ...PublicLinkSchema
    }
    createdAt
    isDone
    brand {
      id
      schema
      theme
      font
      feedback
      palette
      labels
      files {
        ...FileMetaSchema
      }
    }
    isPublic
    passOrder
    passPercentage
    availability
    displayIncompleteModal
    locale
    localeSettingsName
    localeSettings
    employeePreferences {
      ...EmployeePreferencesSchema
    }
    commentators {
      ...CommentatorsSchema
    }
  }
`)

export const projectForExportFragment = gql(`
  fragment ProjectForExportSchema on Project {
    id
    sectionsOrder {
      ...SectionOrderSchema
    }
    sections {
      id
      name
      type
      isHide
      updatedAt
    }
    name
    updatedAt
    learningObjectives
    learningGoals
    createdAt
    isDone
    passPercentage
    locale
  }
`)

export const projectFragmentDeep = gql(`
  fragment ProjectSchemaDeep on Project {
    id
    isPublic
    publicLink {
      ...PublicLinkSchema
    }
    companyId
    projectGroupId
    owner {
      ...EmployeeSmallSchema
    }
    sectionsOrder {
      ...SectionOrderSchema
    }
    sections {
      ...SectionWithBlocksSchema
    }
    hasExcludeItems
    accent
    name
    endDate
    updatedAt
    learningObjectives
    learningGoals
    projectGroupId
    company {
      name
      logo {
        ...FileMetaSchema
      }
      contractType
    }
    brand {
      id
      schema
      theme
      font
      feedback
      palette
      labels
      files {
        ...FileMetaSchema
      }
    }
    fontsGroups {
      ...FontGroupFullSchema
    }
    passOrder
    passPercentage
    availability
    displayIncompleteModal
    locale
    localeSettingsName
    localeSettings
    employeePreferences {
      ...EmployeePreferencesSchema
    }
  }
`)
